import { useEffect } from 'react';
import { assertConfiguration } from "../AblyReactHooks";
export function useChannel(channelName, ...channelSubscriptionArguments) {
    const ably = assertConfiguration();
    const channel = ably.channels.get(channelName);
    const onMount = () => {
        channel.subscribe.apply(channel, channelSubscriptionArguments);
    };
    const onUnmount = () => {
        channel.unsubscribe.apply(channel, channelSubscriptionArguments);
        channel.detach();
    };
    const useEffectHook = () => {
        onMount();
        return () => { onUnmount(); };
    };
    useEffect(useEffectHook, [channelName]);
    return [channel, ably];
}
//# sourceMappingURL=useChannel.js.map